/* globals initTooltips, prepareImagePreview, previewImageSource, isValidImage */
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['preview', 'label', 'tooltipContent', 'file'];

  selectFile() {
    this.fileTarget.click();
  }

  #fileChangeHandler = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      if (!isValidImage(file)) {
        if (this.hasPreviewTarget) {
          this.previewTarget.src = '';
          this.previewTarget.classList.add('hide');
        }
        if (this.hasLabelTarget) {
          this.labelTarget.classList.remove('hide');
          this.labelTarget.classList.add('unsupported', 'tooltip');
          this.labelTarget.querySelector('.tooltip__content')?.remove();
          this.labelTarget.insertAdjacentHTML(
            'afterbegin',
            '<div class="tooltip__content">Unsupported file. Please upload a valid JPEG, PNG, WEBP, AVIF, GIF, or HEIC file (under 10MB).</div>'
          );
          initTooltips(this.labelTarget);
        }
        event.preventDefault();
        event.stopPropagation();
        return;
      } else {
        if (this.hasLabelTarget) {
          this.labelTarget.classList.remove('unsupported', 'tooltip');
          this.labelTarget.querySelector('.tooltip__content')?.remove();
          initTooltips(this.labelTarget);
        }

        const reader = new FileReader();
        reader.onload = (f) => {
          prepareImagePreview(f.target.result, file.name, 100).then((imgData) => {
            if (imgData) {
              this.previewTarget.src = previewImageSource(f.target.result, file.name);
              this.element.classList.add('upload-preview');
            } else {
              alert(
                'Invalid image. Please upload a valid JPEG, PNG, WEBP, AVIF, GIF, or HEIC file.'
              );
            }
          });
        };
        reader.readAsDataURL(file);
      }
    }
  };

  fileTargetConnected(element) {
    element.addEventListener('change', this.#fileChangeHandler);
  }

  fileTargetDisconnected(element) {
    element.removeEventListener('change', this.#fileChangeHandler);
  }

  labelTargetConnected(element) {
    initTooltips(element);
  }
}
